<template>
    <div>
        <v-select :id="`div_`+name"
                  v-model="internalValue"
                  :filterable="false"
                  :name="`div_`+name"
                  :options="selectOptions"
                  :reduce="option => option.id"
                  class="style-chooser"
                  label="name">
            <template slot="no-options">
                Start typing to search...
            </template>
        </v-select>

        <input :id="name" v-model="internalValue" :name="name" type="hidden">
    </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
    name: "SelectBooleanComponent",
    components: {vSelect},
    props: {
        initialValue: {
            type: Number,
            required: true
        },
        name: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            internalValue: '',
            selectOptions: [
                {
                    id: 1,
                    name: 'Yes',
                },
                {
                    id: 0,
                    name: 'No',
                },
            ],
        }
    },
    methods: {},
    mounted() {

        this.internalValue = this.initialValue;
    },
}
</script>

<style scoped>

</style>
